import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Scroll from 'react-scroll';

import config from '../../../config';
import queryString from 'query-string';

import { DeleteWarning, Forms, Help, Loading, Modal, SaveButton, SystemText } from '@salesperformanceint/e4shared';

import { setPrismMenu, setShowSuccess, toggleFormHelp } from 'actions/ui';
import PageHeader from 'components/general/pageHeader';
import LinkedIn from './components/linkedin';
import { apiGet, apiPatch, apiPost } from 'services';
import { loadUserFromLocalStorage } from 'actions/user';
import HighspotHelp from './components/highspotHelp';
import SortFilter from 'components/general/sortFilter';
import { SFTP, SFTPValidation } from './components/sftp';
import { Snowflake, SnowflakeValidation } from './components/snowflake';
import { ConfirmButton } from '@salesperformanceint/e4shared';

export const AdminIntegrations = ({ history, location }) => {
    const dispatch = useDispatch();
    const queryValues = queryString.parse(location.search);
    const [search, setSearch] = React.useState('');
    const [settings, setSettings] = React.useState(null);
    const [saving, setSaving] = React.useState(null);
    const [adminUsers, setAdminUsers] = React.useState([]);
    const [errors, setErrors] = React.useState({});
    const [savingSCIM, setSavingSCIM] = React.useState(false);
    const [showRegenerateWarning, setShowRegenerateWarning] = React.useState(false);
    const [accelerateApiKey, setAccelerateApiKey] = React.useState('');
    const [bespokeCRMKey, setBespokeCRMKey] = React.useState('');
    const [bespokeCRMSecret, setBespokeCRMSecret] = React.useState('');
    const [bespokeCRMUrl, setBespokeCRMUrl] = React.useState('');
    const [clariKey, setClariKey] = React.useState('');
    const [clariCoPilotKey, setClariCoPilotKey] = React.useState('');
    const [clariCoPilotSecret, setClariCoPilotSecret] = React.useState('');
    const [doceboClientId, setDoceboClientId] = React.useState('');
    const [doceboDomain, setDoceboDomain] = React.useState('');
    const [doceboSecret, setDoceboSecret] = React.useState('');
    const [doceboUsername, setDoceboUsername] = React.useState('');
    const [doceboPassword, setDoceboPassword] = React.useState('');
    const [dynamicsClientId, setDynamicsClientId] = React.useState('');
    const [dynamicsDetails, setDynamicsDetails] = React.useState('');
    const [dynamicsSecret, setDynamicsSecret] = React.useState('');
    const [dynamicsTennantId, setDynamicsTennantId] = React.useState('');
    const [dynamicsTestResult, setDynamicsTestResult] = React.useState('');
    const [dynamicsUrl, setDynamicsUrl] = React.useState('');
    const [highSpotDatalakeHostname, setHighSpotDatalakeHostname] = React.useState('');
    const [highSpotDatalakePrivateKey, setHighSpotDatalakePrivateKey] = React.useState('');
    const [highSpotDatalakeUsername, setHighSpotDatalakeUsername] = React.useState('');
    const [highSpotDatalakeVersion, setHighSpotDatalakeVersion] = React.useState('');
    const [highSpotInstanceUrl, setHighSpotInstanceUrl] = React.useState('');
    const [hubspotApiKey, setHubspotApiKey] = React.useState('');
    const [hubspotRefreshToken, setHubspotRefreshToken] = React.useState('');
    const [gtmBuddyApiKey, setGtmBuddyApiKey] = React.useState('');
    const [gtmBuddyApiUrl, setGtmBuddyApiUrl] = React.useState('');
    const [gongApiKey, setGongApiKey] = React.useState('');
    const [gongApiSecret, setGongApiSecret] = React.useState('');
    const [googleDomain, setGoogleDomain] = React.useState('');
    const [learning360APIKey, setLearning360APIKey] = React.useState('');
    const [learning360CompanyId, setLearning360CompanyId] = React.useState('');
    const [learning360InstanceUrl, setLearning360InstanceUrl] = React.useState('');
    const [lessonlyAPIKey, setLessonlyAPIKey] = React.useState('');
    const [lessonlySubDomain, setLessonlySubDomain] = React.useState('');
    const [linkedInAlert, setLinkedInAlert] = React.useState(null);
    const [peopleHRUse, setPeopleHRUse] = React.useState(false);
    const [peopleHRAPIKey, setPeopleHRAPIKey] = React.useState('');
    const [peopleHRQuery, setPeopleHRQuery] = React.useState('');
    const [pipedriveApiKey, setPipedriveApiKey] = React.useState('');
    const [pulseHost, setPulseHost] = React.useState('');
    const [pulseUsername, setPulseUsername] = React.useState('');
    const [pulsePassword, setPulsePassword] = React.useState('');
    const [odbcConnection, setOdbcConnection] = React.useState('');
    const [odbcName, setOdbcName] = React.useState('');
    const [odbcSource, setOdbcSource] = React.useState('');
    const [odbcView, setOdbcView] = React.useState('');
    const [odbcTestResult, setOdbcTestResult] = React.useState('');
    const [outreachRefreshToken, setOutreachRefreshToken] = React.useState('');
    const [salesforceId, setSalesforceId] = React.useState('');
    const [salesforceUsername, setSalesforceUsername] = React.useState('');
    const [salesforcePassword, setSalesforcePassword] = React.useState('');
    const [salesforceClientId, setSalesforceClientId] = React.useState('');
    const [salesforceSecret, setSalesforceSecret] = React.useState('');
    const [salesforceRefreshToken, setSalesforceRefreshToken] = React.useState('');
    const [salesforceSandbox, setSalesforceSandbox] = React.useState(false);
    const [salesforceTestResult, setSalesforceTestResult] = React.useState('');
    const [salesloftApiKey, setSalesloftApiKey] = React.useState('');
    const [sapSubDomain, setSapSubDomain] = React.useState('');
    const [sapUsername, setSapUsername] = React.useState('');
    const [sapPassword, setSapPassword] = React.useState('');
    const [samlCertificate, setSamlCertificate] = React.useState('');
    const [samlEntityId, setSamlEntityId] = React.useState('');
    const [samlLoginUrl, setSamlLoginUrl] = React.useState('');
    const [samlOnly, setSamlOnly] = React.useState(false);
    const [scimToken, setScimToken] = React.useState('');
    const [scimUse, setScimUse] = React.useState(false);
    const [scimSync, setScimSync] = React.useState(null);
    const [sftpHost, setSftpHost] = React.useState('');
    const [sftpPort, setSftpPort] = React.useState(22);
    const [sftpUsername, setSftpUsername] = React.useState('');
    const [sftpPassword, setSftpPassword] = React.useState('');
    const [sftpFiles, setSftpFiles] = React.useState('');
    const [showpadSubdomain, setShowpadSubdomain] = React.useState('');
    const [showpadClientId, setShowpadClientId] = React.useState('');
    const [showpadSecret, setShowpadSecret] = React.useState('');
    const [showpadRefreshToken, setShowpadRefreshToken] = React.useState('');
    const [snowflakeDetails, setSnowflakeDetails] = React.useState('');
    const [useLinkedIn, setUseLinkedIn] = React.useState(false);
    const [showLinkedIn, setShowLinkedIn] = React.useState(false);
    const [showSalesforceClassic, setShowSalesforceClassic] = React.useState(false);
    const [showSave, setShowSave] = React.useState(true);
    const [loadingSalesforceTest, setLoadingSalesforceTest] = React.useState(true);
    const [showForm, setShowForm] = React.useState(queryValues.show);
    const [manualSalesforceSwap, setManualSalesforceSwap] = React.useState(false);

    const mandatoryScim = ['Email', 'Firstname', 'Lastname', 'Licence'];

    const user = useSelector(state => state.user.user);

    const useSalesForceEcam =
        config.environment === 'nick-dev' ||
        (config.environment === 'preview' && user.company_Id >= 193) ||
        (config.environment === 'live' && user.company_Id >= 181) ||
        (config.environment === 'live' && user.company_Id === 85); // only for companies created after 181 in prod and 193 in preview, We are also migrating Rich Products(85)

    const { showFormHelp } = useSelector(state => state.ui);

    const sfurl = `https://login.salesforce.com/services/oauth2/authorize?response_type=code&client_id=${config.salesforce.clientId}&redirect_uri=${config.url}oauth/salesforce/callback&state=mystate`;

    const st = (path, ...rest) => SystemText(`Admin/Integrations/${path}`, ...rest);

    React.useEffect(() => {
        dispatch(setPrismMenu('Admin'));
    }, []);

    React.useEffect(() => {
        let hideSave = showForm === 'Salesforce' && !showSalesforceClassic;
        hideSave = hideSave || (showForm === 'Salesforce' && useSalesForceEcam);
        hideSave = hideSave || (showForm === 'PeopleHR' && scimUse);
        hideSave = hideSave || (showForm === 'SCIM' && peopleHRUse);
        setShowSave(!hideSave);
    }, [showSalesforceClassic, showForm]);

    React.useEffect(() => {
        if (useSalesForceEcam) {
            setLoadingSalesforceTest(true);
            apiGet('salesforce-ecam-test', user.guid, result => {
                setSalesforceTestResult(result);
                setLoadingSalesforceTest(false);
            });

            return;
        }
        if (salesforceRefreshToken || (salesforceClientId && salesforceSecret && salesforceUsername && salesforcePassword)) {
            setLoadingSalesforceTest(true);
            apiGet(
                `salesforce-test?type=${showSalesforceClassic}&u=${salesforceUsername}&p=${salesforcePassword}&c=${salesforceClientId}&s=${salesforceSecret}&x=${salesforceSandbox}`,
                user.guid,
                result => {
                    if (result !== 'OK' && !showSalesforceClassic && salesforceUsername && !manualSalesforceSwap) {
                        setShowSalesforceClassic(true);
                    } else {
                        setSalesforceTestResult(result);
                    }

                    setLoadingSalesforceTest(false);
                },
                null,
                true
            );
        } else {
            setLoadingSalesforceTest(false);
            setSalesforceTestResult('');
        }
    }, [
        showSalesforceClassic,
        salesforceClientId,
        salesforceSecret,
        salesforceUsername,
        salesforcePassword,
        salesforceSandbox,
        salesforceRefreshToken,
    ]);

    const loadSettings = () => {
        apiGet('setting', user.guid, result => setSettings(result));
    };

    const loadAdminUsers = () => {
        apiGet('profile-admins', user.guid, result => setAdminUsers(result));
    };

    React.useEffect(() => {
        loadSettings();
        loadAdminUsers();
    }, []);

    React.useEffect(() => {
        if (settings) {
            const json = settings.settings ? settings.settings : '{}';
            const parsedJson = JSON.parse(json);
            const integration = parsedJson.integration || {};

            setAccelerateApiKey(accelerateApiKey || integration.accelerateApiKey);
            setBespokeCRMKey(bespokeCRMKey || integration.bespokeCRMKey);
            setBespokeCRMSecret(bespokeCRMSecret || integration.bespokeCRMSecret);
            setBespokeCRMUrl(bespokeCRMUrl || integration.bespokeCRMUrl);
            setClariKey(clariKey || integration.clariKey);
            setClariCoPilotKey(clariCoPilotKey || integration.clariCoPilotKey);
            setClariCoPilotSecret(clariCoPilotSecret || integration.clariCoPilotSecret);
            setDoceboClientId(doceboClientId || integration.doceboClientId);
            setDoceboDomain(doceboDomain || integration.doceboDomain);
            setDoceboSecret(doceboSecret || integration.doceboSecret);
            setDoceboUsername(doceboUsername || integration.doceboUsername);
            setDoceboPassword(doceboPassword || integration.doceboPassword);
            setDynamicsClientId(dynamicsClientId || integration.dynamicsClientId);
            setDynamicsSecret(dynamicsSecret || integration.dynamicsSecret);
            setDynamicsTennantId(dynamicsTennantId || integration.dynamicsTennantId);
            setDynamicsUrl(dynamicsUrl || integration.dynamicsUrl);
            setHighSpotDatalakeHostname(highSpotDatalakeHostname || integration.highSpotDatalakeHostname);
            setHighSpotDatalakePrivateKey(highSpotDatalakePrivateKey || integration.highSpotDatalakePrivateKey);
            setHighSpotDatalakeUsername(highSpotDatalakeUsername || integration.highSpotDatalakeUsername);
            setHighSpotDatalakeVersion(highSpotDatalakeVersion || integration.highSpotDatalakeVersion);
            setHubspotApiKey(hubspotApiKey || integration.hubspotApiKey);
            setHubspotRefreshToken(hubspotRefreshToken || integration.hubspotRefreshToken);
            setGongApiKey(gongApiKey || integration.gongApiKey);
            setGongApiSecret(gongApiSecret || integration.gongApiSecret);
            setGoogleDomain(googleDomain || integration.googleDomain);
            setGtmBuddyApiKey(gtmBuddyApiKey || integration.gtmBuddyApiKey);
            setGtmBuddyApiUrl(gtmBuddyApiUrl || integration.gtmBuddyApiUrl);
            setLearning360APIKey(learning360APIKey || integration.learning360APIKey);
            setLearning360CompanyId(learning360CompanyId || integration.learning360CompanyId);
            setLearning360InstanceUrl(learning360InstanceUrl || integration.learning360InstanceUrl);
            setLessonlyAPIKey(lessonlyAPIKey || integration.lessonlyAPIKey);
            setLessonlySubDomain(lessonlySubDomain || integration.lessonlySubDomain);
            setLinkedInAlert(linkedInAlert || integration.linkedInAlert);
            setOutreachRefreshToken(outreachRefreshToken || integration.outreachRefreshToken);
            setOdbcConnection(odbcConnection || integration.odbcConnection);
            setOdbcName(odbcName || integration.odbcName);
            setOdbcSource(odbcSource || integration.odbcSource || 'MS-SQL');
            setOdbcView(odbcView || integration.odbcView);
            setPeopleHRUse(peopleHRUse || integration.peopleHRUse);
            setPeopleHRAPIKey(peopleHRAPIKey || integration.peopleHRAPIKey);
            setPeopleHRQuery(peopleHRQuery || integration.peopleHRQuery);
            setPipedriveApiKey(pipedriveApiKey || integration.pipedriveApiKey);
            setPulseHost(pulseHost || integration.pulseHost);
            setPulseUsername(pulseUsername || integration.pulseUsername);
            setPulsePassword(pulsePassword || integration.pulsePassword);
            setSalesforceId(salesforceId || integration.salesforceId);
            setSalesforceUsername(salesforceUsername || integration.salesforceUsername);
            setSalesforcePassword(salesforcePassword || integration.salesforcePassword);
            setSalesforceClientId(salesforceClientId || integration.salesforceClientId);
            setSalesforceSecret(salesforceSecret || integration.salesforceSecret);
            setSalesforceRefreshToken(salesforceRefreshToken || integration.salesforceRefreshToken);
            setSalesforceSandbox(salesforceSandbox || integration.salesforceSandbox || false);
            setSalesloftApiKey(salesloftApiKey || integration.salesloftApiKey);
            setSapSubDomain(sapSubDomain || integration.sapSubDomain);
            setSapUsername(sapUsername || integration.sapUsername);
            setSapPassword(sapPassword || integration.sapPassword);
            setSamlCertificate(samlCertificate || integration.samlCertificate);
            setSamlEntityId(samlEntityId || integration.samlEntityId);
            setSamlLoginUrl(samlLoginUrl || integration.samlLoginUrl);
            setSamlOnly(samlOnly || integration.samlOnly);
            setShowpadSubdomain(showpadSubdomain || integration.showpadSubdomain);
            setShowpadClientId(showpadClientId || integration.showpadClientId);
            setShowpadSecret(showpadSecret || integration.showpadSecret);
            setShowpadRefreshToken(showpadRefreshToken || integration.showpadRefreshToken);
            setScimUse(scimUse || integration.scimUse);
            setScimSync(
                scimSync ||
                    (integration.scimSync || [])
                        .concat(mandatoryScim)
                        .reduce((a, c) => (a.some(a => a === c) ? a : a.concat([c])), [])
            );
            setSftpHost(integration.sftpHost);
            setSftpPort(integration.sftpPort || 22);
            setSftpUsername(integration.sftpUsername);
            setSftpPassword(integration.sftpPassword);
            setSftpFiles(integration.sftpFiles);
            setUseLinkedIn(useLinkedIn || integration.useLinkedIn);
            setDynamicsDetails(integration.dynamicsClientId ? true : false);
            setScimToken(settings.scim_Token);
            setSnowflakeDetails(integration.snowflakeDetails);
        }
    }, [settings]);

    const testConnection = (integration, qs, callback) => {
        apiGet(`${integration}-test${qs}`, user.guid, result => callback(result), null, true);
    };

    const disconnect = () => {
        if (useSalesForceEcam) {
            apiPost('salesforce-ecam-disconnect', null, user.guid, () => {
                setSalesforceClientId('');
                setSalesforceSecret('');
                setSalesforceSandbox(false);
                setSalesforceTestResult('');
            });
        }
        apiPost('salesforce-disconnect', null, user.guid, () => {
            setSalesforceTestResult('');
        });
    };

    const regenerateSCIM = confirm => {
        confirm &&
            apiPatch(`scim-regenerate`, null, user.guid, () => {
                loadSettings();
            });

        setSavingSCIM(false);
        setShowRegenerateWarning(false);
    };

    const revertForm = () => {
        const json = settings.settings ? settings.settings : '{}';
        const parsedJson = JSON.parse(json);
        const integration = parsedJson.integration || {};

        setAccelerateApiKey(integration.accelerateApiKey);
        setBespokeCRMKey(integration.bespokeCRMKey);
        setBespokeCRMSecret(integration.bespokeCRMSecret);
        setBespokeCRMUrl(integration.bespokeCRMUrl);
        setClariKey(integration.clariKey);
        setClariCoPilotKey(integration.clariCoPilotKey);
        setClariCoPilotKey(integration.clariCoPilotSecret);
        setDoceboClientId(integration.doceboClientId);
        setDoceboDomain(integration.doceboDomain);
        setDoceboSecret(integration.doceboSecret);
        setDoceboUsername(integration.doceboPassword);
        setDoceboPassword(integration.doceboPassword);
        setDynamicsClientId(integration.dynamicsClientId);
        setDynamicsSecret(integration.dynamicsSecret);
        setDynamicsTennantId(integration.dynamicsTennantId);
        setDynamicsUrl(integration.dynamicsUrl);
        setHighSpotDatalakeHostname(integration.highSpotDatalakeHostname);
        setHighSpotDatalakePrivateKey(integration.highSpotDatalakePrivateKey);
        setHighSpotDatalakeUsername(integration.highSpotDatalakeUsername);
        setHighSpotDatalakeVersion(integration.highSpotDatalakeVersion);
        setHubspotApiKey(integration.hubspotApiKey);
        setHubspotRefreshToken(integration.hubspotRefreshToken);
        setGongApiKey(integration.gongApiKey);
        setGongApiSecret(integration.gongApiSecret);
        setGoogleDomain(integration.googleDomain);
        setGtmBuddyApiKey(integration.gtmBuddyApiKey);
        setGtmBuddyApiUrl(integration.gtmBuddyApiUrl);
        setLearning360APIKey(integration.learning360APIKey);
        setLearning360CompanyId(integration.learning360CompanyId);
        setLearning360InstanceUrl(integration.learning360InstanceUrl);
        setLessonlyAPIKey(integration.lessonlyAPIKey);
        setLessonlySubDomain(integration.lessonlySubDomain);
        setLinkedInAlert(integration.linkedInAlert || []);
        setOdbcConnection(integration.odbcConnection);
        setOdbcName(integration.odbcName);
        setOdbcSource(integration.odbcSource);
        setOdbcView(integration.odbcView);
        setOutreachRefreshToken(integration.outreachRefreshToken);
        setPeopleHRUse(integration.peopleHRUse);
        setPeopleHRAPIKey(integration.peopleHRAPIKey);
        setPeopleHRQuery(integration.peopleHRQuery);
        setPipedriveApiKey(integration.pipedriveApiKey);
        setPulseHost(integration.pulseHost);
        setPulseUsername(integration.pulseUsername);
        setPulsePassword(integration.pulsePassword);
        setSalesforceId(integration.salesforceId);
        setSalesforceUsername(integration.salesforceUsername);
        setSalesforcePassword(integration.salesforcePassword);
        setSalesforceClientId(integration.salesforceClientId);
        setSalesforceSecret(integration.salesforceSecret);
        setSalesforceRefreshToken(integration.salesforceRefreshToken);
        setSalesforceSandbox(integration.salesforceSandbox || false);
        setSalesloftApiKey(integration.salesloftApiKey);
        setSapSubDomain(integration.sapSubDomain);
        setSapUsername(integration.sapUsername);
        setSapPassword(integration.sapPassword);
        setSamlCertificate(integration.samlCertificate);
        setSamlEntityId(integration.samlEntityId);
        setSamlLoginUrl(integration.samlLoginUrl);
        setSamlOnly(integration.samlOnly);
        setSftpHost(integration.sftpHost);
        setSftpPort(integration.sftpPort);
        setSftpUsername(integration.sftpUsername);
        setSftpPassword(integration.sftpPassword);
        setSftpFiles(integration.sftpFiles);
        setShowpadSubdomain(integration.showpadSubdomain);
        setShowpadClientId(integration.showpadClientId);
        setShowpadSecret(integration.showpadSecret);
        setShowpadRefreshToken(integration.showpadRefreshToken);
        setScimUse(integration.scimUse);
        setScimSync(
            integration.scimSync.concat(mandatoryScim).reduce((a, c) => (a.some(a => a === c) ? a : a.concat([c])), [])
        );
        setSnowflakeDetails(integration.snowflakeDetails);
        setUseLinkedIn(integration.useLinkedIn);
        setDynamicsDetails(integration.dynamicsClientId ? true : false);
        setScimToken(settings.scim_Token);
    };

    const validate = async () => {
        const temp = {};
        let isValid = true;

        switch (showForm) {
            case 'SFTP':
                const sftpValid = SFTPValidation(sftpHost, sftpPort, sftpUsername, sftpPassword, sftpFiles, temp, user);
                isValid = await Promise.resolve(sftpValid);
                break;
            case 'Snowflake':
                const snowflakeValid = SnowflakeValidation(snowflakeDetails, temp, user);
                isValid = await Promise.resolve(snowflakeValid);
                break;
            default:
                break;
        }

        setErrors(temp);
        return isValid;
    };

    const save = async () => {
        const json = settings.settings ? settings.settings : '{}';
        const parsedJson = JSON.parse(json);
        const valid = await validate();
        if (!valid) {
            setSaving(false);
            return;
        }

        const temp = JSON.stringify({
            ...parsedJson,
            integration: {
                accelerateApiKey,
                bespokeCRMKey,
                bespokeCRMSecret,
                bespokeCRMUrl,
                clariKey,
                clariCoPilotKey,
                clariCoPilotSecret,
                doceboClientId,
                doceboDomain,
                doceboSecret,
                doceboUsername,
                doceboPassword,
                dynamicsClientId,
                dynamicsSecret,
                dynamicsTennantId,
                dynamicsUrl,
                highSpotDatalakeHostname,
                highSpotDatalakeUsername,
                highSpotDatalakeVersion,
                highSpotDatalakePrivateKey,
                hubspotApiKey,
                hubspotRefreshToken,
                gongApiKey,
                gongApiSecret,
                googleDomain,
                gtmBuddyApiKey,
                gtmBuddyApiUrl,
                learning360APIKey,
                learning360CompanyId,
                learning360InstanceUrl,
                lessonlyAPIKey,
                lessonlySubDomain,
                linkedInAlert,
                odbcConnection,
                odbcName,
                odbcSource,
                odbcView,
                outreachRefreshToken,
                peopleHRUse,
                peopleHRAPIKey,
                peopleHRQuery,
                pipedriveApiKey,
                pulseHost,
                pulseUsername,
                pulsePassword,
                salesforceId,
                salesforceUsername,
                salesforcePassword,
                salesforceClientId,
                salesforceSecret,
                salesforceRefreshToken,
                salesforceSandbox,
                salesloftApiKey,
                sapSubDomain,
                sapUsername,
                sapPassword,
                samlCertificate,
                samlEntityId,
                samlLoginUrl,
                samlOnly,
                scimUse,
                scimSync,
                sftpHost,
                sftpPort,
                sftpUsername,
                sftpPassword,
                sftpFiles,
                showpadSubdomain,
                showpadClientId,
                showpadSecret,
                showpadRefreshToken,
                snowflakeDetails,
                useLinkedIn: useLinkedIn || false,
            },
        });

        const result = {
            ...settings,
            settings: temp,
        };

        apiPatch('setting', result, user.guid, () => {
            dispatch(loadUserFromLocalStorage(history));
            const module = st(`${showForm}/Title`);
            dispatch(setShowSuccess(st('Success', module)));
            loadSettings();
            setShowForm('');
            setSaving(false);
        });
    };

    if (!user.sys_Config) history.replace('/');

    const connectToSalesForceEcam = () => {
        window.open(
            `${config.apiGateway.URL}auth/salesforce/connect?${config.apiGateway.CODE}&token=${encodeURIComponent(user.guid)}&clientid=${encodeURIComponent(salesforceClientId)}&secret=${encodeURIComponent(salesforceSecret)}&sandbox=${salesforceSandbox}`,
            '_blank'
        );
    };

    const salesforceValidOrNot = (showInvalid = true) =>
        loadingSalesforceTest ? (
            <i className="fa fa-spinner fa-spin text-sm" />
        ) : salesforceTestResult === 'OK' ? (
            <span className="flex flex-center">
                <i title={st('Salesforce/Connect/Valid')} className="ml5 mr10 fa text-lg fa-check-circle text-green" />
                <span>{st('Salesforce/Congratulations')}</span>
            </span>
        ) : (
            showInvalid &&
            salesforceTestResult && (
                <span>
                    <Help id="salesforce-error" target={<i className="ml5 mr10 fa text-lg fa-times-circle text-red" />}>
                        {salesforceTestResult}
                    </Help>
                    <span>{st('Salesforce/Sorry')}</span>
                </span>
            )
        );

    const fixedEncodeURIComponent = str => {
        return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
            return '%' + c.charCodeAt(0).toString(16);
        });
    };

    const salesforceEcamValidOrNot = (showInvalid = true) => {
        return loadingSalesforceTest ? (
            <i className="fa fa-spinner fa-spin text-sm" />
        ) : salesforceTestResult && salesforceTestResult.success ? (
            <span className="flex flex-center">
                <i title={st('Salesforce/Connect/Valid')} className="mr10 fa text-lg fa-check-circle positive" />
                <span>{st('Salesforce/Congratulations')}</span>
            </span>
        ) : (
            showInvalid &&
            salesforceTestResult && (
                <span>
                    <Help id="salesforce-error" target={<i className="ml5 mr10 fa text-lg fa-times-circle text-red" />}>
                        {salesforceTestResult.tenant}
                    </Help>
                    <span>{st('Salesforce/Sorry')}</span>
                </span>
            )
        );
    };

    const salesForceEcamForm = () => {
        if (salesforceTestResult && salesforceTestResult.success) {
            return {
                key: 'Salesforce',
                tags: ['CRM'],
                form: (
                    <>
                        <div className="mt10">
                            <label class="mr10 bold">{st('SalesforceEcam/TenantName')}</label>
                            {salesforceTestResult.instanceName}
                        </div>
                        <div className="mt10">
                            <label class="mr10 bold">{st('SalesforceEcam/TenantType')}</label>
                            {salesforceTestResult.isSandbox
                                ? st('SalesforceEcam/TenantType/Sandbox')
                                : st('SalesforceEcam/TenantType/Production')}
                        </div>
                        <div className="mt10">{salesforceEcamValidOrNot(true)}</div>
                        {user.partner_Id && user.partner_Id > 0 && (
                            <div className="mt10">
                                <button
                                    className="btn btn-warning"
                                    onClick={() => {
                                        window.open(salesforceTestResult.tenant, '_blank');
                                    }}
                                >
                                    {st('SalesforceEcam/Tenant/Open')}
                                </button>
                            </div>
                        )}
                        <div className="mt10">
                            <ConfirmButton helpText={st('SalesforceEcam/Disconnect/Warning')}>
                                <button className="btn btn-default" onClick={e => disconnect(e)}>
                                    {st('SalesforceEcam/Tenant/Disconnect')}
                                </button>
                            </ConfirmButton>
                        </div>
                    </>
                ),
            };
        }

        return {
            key: 'Salesforce',
            tags: ['CRM'],
            form: (
                <>
                    <Forms.Text
                        key="skkey"
                        id="sfkey"
                        label={st('SalesforceEcam/Fields/Key/Label')}
                        help={st('Salesforce/Fields/Key/Help')}
                        onChange={setSalesforceClientId}
                        value={salesforceClientId}
                    />
                    <Forms.Text
                        key="sfsecret"
                        id="sfsecret"
                        label={st('SalesforceEcam/Fields/Secret/Label')}
                        help={st('Salesforce/Fields/Secret/Help')}
                        onChange={setSalesforceSecret}
                        value={salesforceSecret}
                    />
                    <Forms.Toggle
                        key="sfsandbox"
                        id="sfsandbox"
                        label={st('Salesforce/Fields/Sandbox/Label')}
                        help={st('Salesforce/Fields/Sandbox/Help')}
                        onChange={setSalesforceSandbox}
                        value={salesforceSandbox}
                    />
                    <div className="mt10">
                        <button
                            className="btn btn-sm"
                            onClick={() => {
                                connectToSalesForceEcam();
                            }}
                        >
                            {st('Salesforce/Connect/App')}
                        </button>
                    </div>
                </>
            ),
        };
    };

    const salesforce = useSalesForceEcam
        ? salesForceEcamForm()
        : {
              key: 'Salesforce',
              tags: ['CRM'],
              form: showSalesforceClassic ? (
                  <>
                      <Forms.Text
                          key="sforgid"
                          id="sforgid"
                          label={st('Salesforce/Fields/Organisation/Label')}
                          help={st('Salesforce/Fields/Organisation/Help')}
                          onChange={setSalesforceId}
                          value={salesforceId}
                      />
                      <Forms.Text
                          key="sfusername"
                          id="sfusername"
                          label={st('Salesforce/Fields/Username/Label')}
                          help={st('Salesforce/Fields/Username/Help')}
                          onChange={setSalesforceUsername}
                          value={salesforceUsername}
                      />
                      <Forms.Text
                          key="sfpassword"
                          id="sfpassword"
                          label={st('Salesforce/Fields/Password/Label')}
                          help={st('Salesforce/Fields/Password/Help')}
                          onChange={setSalesforcePassword}
                          value={salesforcePassword}
                          type="password"
                      />
                      <Forms.Text
                          key="skkey"
                          id="sfkey"
                          label={st('Salesforce/Fields/Key/Label')}
                          help={st('Salesforce/Fields/Key/Help')}
                          onChange={setSalesforceClientId}
                          value={salesforceClientId}
                      />
                      <Forms.Text
                          key="sfsecret"
                          id="sfsecret"
                          label={st('Salesforce/Fields/Secret/Label')}
                          help={st('Salesforce/Fields/Secret/Help')}
                          onChange={setSalesforceSecret}
                          value={salesforceSecret}
                          type="password"
                      />
                      <Forms.Toggle
                          key="sfsandbox"
                          id="sfsandbox"
                          label={st('Salesforce/Fields/Sandbox/Label')}
                          help={st('Salesforce/Fields/Sandbox/Help')}
                          onChange={setSalesforceSandbox}
                          value={salesforceSandbox}
                      />
                      <div>{salesforceValidOrNot()}</div>
                      <div className="mt10">
                          <button
                              className="btn btn-link btn-sm"
                              onClick={() => {
                                  setShowSalesforceClassic(false);
                                  setManualSalesforceSwap(true);
                              }}
                          >
                              {st('Salesforce/Connect/User')}
                          </button>
                      </div>
                  </>
              ) : (
                  <>
                      <div className="flex flex-center">
                          <button
                              className="btn btn-warning"
                              disabled={salesforceTestResult === 'OK'}
                              onClick={() => {
                                  window.location.href = sfurl;
                              }}
                          >
                              {st('Salesforce/Connect/Button')}
                          </button>
                          <span className="ml10">{salesforceValidOrNot(false)}</span>
                      </div>
                      <div className="mt10">
                          {salesforceTestResult === 'OK' ? (
                              <button className="btn btn-link btn-sm" onClick={() => disconnect()}>
                                  {st('Salesforce/Connect/Disconnect')}
                              </button>
                          ) : (
                              <button
                                  className="btn btn-link btn-sm"
                                  onClick={() => {
                                      setShowSalesforceClassic(true);
                                      setManualSalesforceSwap(true);
                                  }}
                              >
                                  {st('Salesforce/Connect/App')}
                              </button>
                          )}
                      </div>
                  </>
              ),
          };

    const integrations = [
        {
            key: '360Learning',
            tags: ['LMS'],
            form: (
                <>
                    <Forms.Text
                        key="learning360CompanyId"
                        id="learning360CompanyId"
                        label={st('360Learning/Fields/CompanyId/Label')}
                        help={st('360Learning/Fields/CompanyId/Help')}
                        onChange={setLearning360CompanyId}
                        value={learning360CompanyId}
                    />
                    <Forms.Text
                        key="learning360APIKey"
                        id="learning360APIKey"
                        label={st('360Learning/Fields/Key/Label')}
                        help={st('360Learning/Fields/Key/Help')}
                        onChange={setLearning360APIKey}
                        value={learning360APIKey}
                        type="password"
                    />
                    <Forms.Text
                        key="learning360InstanceUrl"
                        id="learning360InstanceUrl"
                        label={st('360Learning/Fields/Url/Label')}
                        help={st('360Learning/Fields/Url/Help')}
                        placeholder={st('360Learning/Fields/Url/Placeholder')}
                        onChange={setLearning360InstanceUrl}
                        value={learning360InstanceUrl}
                    />
                </>
            ),
        },
        {
            key: 'Accelerate',
            tags: ['LMS'],
            form: (
                <>
                    <Forms.Text
                        key="accelerateApiKey"
                        data-testid="accelerateApiKey"
                        label={st('Accelerate/Fields/ApiKey/Label')}
                        help={st('Accelerate/Fields/ApiKey/Help')}
                        onChange={setAccelerateApiKey}
                        value={accelerateApiKey}
                        type="password"
                    />
                    <Forms.Label
                        data-testid="accelerateWebhook"
                        label={st('Accelerate/Fields/Webhook/Label')}
                        help={st('Accelerate/Fields/Webhook/Help')}
                        value={`${config.apiGateway.URL}learn-sync/${user.subDomain}`}
                    />
                </>
            ),
        },
        {
            key: 'BespokeCRM',
            tags: ['CRM'],
            form: (
                <>
                    <Forms.Text
                        key="bespokeCRMUrl"
                        id="bespokeCRMUrl"
                        label={st('BespokeCRM/Fields/Url/Label')}
                        placeholder={st('BespokeCRM/Fields/Url/Placeholder')}
                        onChange={setBespokeCRMUrl}
                        value={bespokeCRMUrl}
                    />
                    <Forms.Text
                        key="bespokeCRMKey"
                        id="bespokeCRMKey"
                        label={st('BespokeCRM/Fields/Key/Label')}
                        onChange={setBespokeCRMKey}
                        value={bespokeCRMKey}
                    />
                    <Forms.Text
                        key="bespokeCRMSecret"
                        id="bespokeCRMSecret"
                        label={st('BespokeCRM/Fields/Secret/Label')}
                        help={st('BespokeCRM/Fields/Secret/Help')}
                        onChange={setBespokeCRMSecret}
                        value={bespokeCRMSecret}
                        type="password"
                    />
                </>
            ),
        },
        {
            key: 'Clari',
            tags: ['chat', 'quotas'],
            form: (
                <>
                    {/* <Forms.Text
                        key="clariKey"
                        data-testid="clariKey"
                        label={st('Clari/Fields/Key/Label')}
                        help={st('Clari/Fields/Key/Help')}
                        onChange={setClariKey}
                        value={clariKey}
                    /> */}
                    <Forms.Text
                        key="clariCoPilotKey"
                        data-testid="clariCoPilotKey"
                        label={st('Clari/Fields/CPKey/Label')}
                        help={st('Clari/Fields/CPKey/Help')}
                        onChange={setClariCoPilotKey}
                        value={clariCoPilotKey}
                    />
                    <Forms.Text
                        key="clariCoPilotSecret"
                        data-testid="clariCoPilotSecret"
                        type="password"
                        label={st('Clari/Fields/CPSecret/Label')}
                        help={st('Clari/Fields/CPSecret/Help')}
                        onChange={setClariCoPilotSecret}
                        value={clariCoPilotSecret}
                    />
                </>
            ),
        },
        {
            key: 'Docebo',
            tags: ['LMS'],
            form: (
                <>
                    <Forms.Text
                        key="doceboDomain"
                        data-testid="doceboDomain"
                        label={st('Docebo/Fields/Domain/Label')}
                        help={st('Docebo/Fields/Domain/Help')}
                        placeholder={st('Docebo/Fields/Domain/Placeholder')}
                        onChange={setDoceboDomain}
                        value={doceboDomain}
                    />
                    <Forms.Text
                        key="doceboClientId"
                        data-testid="doceboClientId"
                        label={st('Docebo/Fields/ClientId/Label')}
                        help={st('Docebo/Fields/ClientId/Help')}
                        placeholder={st('Docebo/Fields/ClientId/Placeholder')}
                        onChange={setDoceboClientId}
                        value={doceboClientId}
                    />
                    <Forms.Text
                        key="doceboSecret"
                        data-testid="doceboSecret"
                        label={st('Docebo/Fields/Secret/Label')}
                        help={st('Docebo/Fields/Secret/Help')}
                        type="password"
                        onChange={setDoceboSecret}
                        value={doceboSecret}
                    />
                    <Forms.Text
                        key="doceboUsername"
                        data-testid="doceboUsername"
                        label={st('Docebo/Fields/Username/Label')}
                        help={st('Docebo/Fields/Username/Help')}
                        placeholder={st('Docebo/Fields/Username/Placeholder')}
                        onChange={setDoceboUsername}
                        value={doceboUsername}
                    />
                    <Forms.Text
                        key="doceboPassword"
                        data-testid="doceboPassword"
                        label={st('Docebo/Fields/Password/Label')}
                        help={st('Docebo/Fields/Password/Help')}
                        type="password"
                        onChange={setDoceboPassword}
                        value={doceboPassword}
                    />
                </>
            ),
        },
        {
            key: 'Dynamics',
            tags: ['CRM'],
            form: (
                <>
                    <Forms.Text
                        key="dynamicsUrl"
                        id="dynamicsUrl"
                        label={st('Dynamics/Fields/Url/Label')}
                        placeholder={st('Dynamics/Fields/Url/Placeholder')}
                        onChange={setDynamicsUrl}
                        value={dynamicsUrl}
                    />
                    <Forms.Text
                        key="dynamicsTennantId"
                        id="dynamicsTennantId"
                        label={st('Dynamics/Fields/TennantId/Label')}
                        onChange={setDynamicsTennantId}
                        value={dynamicsTennantId}
                    />
                    <Forms.Text
                        key="dynamicsClientId"
                        id="dynamicsClientId"
                        label={st('Dynamics/Fields/ClientId/Label')}
                        onChange={setDynamicsClientId}
                        value={dynamicsClientId}
                    />
                    <Forms.Text
                        key="dynamicsSecret"
                        id="dynamicsSecret"
                        label={st('Dynamics/Fields/Secret/Label')}
                        help={st('Dynamics/Fields/Secret/Help')}
                        onChange={setDynamicsSecret}
                        value={dynamicsSecret}
                        type="password"
                    />
                    {dynamicsDetails && (
                        <div>
                            <div>
                                <button
                                    className="btn btn-primary"
                                    onClick={() => testConnection('dynamics', '', setDynamicsTestResult)}
                                >
                                    {st('Dynamics/Test')}
                                </button>
                                {dynamicsTestResult && (
                                    <i
                                        title={dynamicsTestResult}
                                        className={`ml5 fa text-lg ${
                                            dynamicsTestResult === 'OK'
                                                ? 'fa-check-circle text-green'
                                                : 'fa-times-circle text-red'
                                        }`}
                                    />
                                )}
                            </div>
                            <div className="text-sm mt5">{st('Dynamics/Test/Help')}</div>
                        </div>
                    )}
                </>
            ),
        },
        {
            key: 'Gong',
            tags: ['chat'],
            module: 'integrations',
            form: (
                <>
                    <Forms.Text
                        key="gongApiKey"
                        id="gongApiKey"
                        label={st('Gong/Fields/ApiKey/Label')}
                        help={st('Gong/Fields/ApiKey/Help')}
                        onChange={setGongApiKey}
                        value={gongApiKey}
                    />
                    <Forms.Text
                        key="gongApiSecret"
                        id="gongApiSecret"
                        label={st('Gong/Fields/ApiSecret/Label')}
                        help={st('Gong/Fields/ApiSecret/Help')}
                        type="password"
                        onChange={setGongApiSecret}
                        value={gongApiSecret}
                    />
                </>
            ),
        },
        {
            key: 'Google',
            tags: ['content'],
            form: (
                <Forms.Text
                    key="googleDomain"
                    id="googleDomain"
                    label={st('Google/Fields/Domain/Label')}
                    help={st('Google/Fields/Domain/Help')}
                    placeholder={st('Google/Fields/Domain/Placeholder')}
                    value={googleDomain}
                    onChange={setGoogleDomain}
                />
            ),
        },
        {
            key: 'GtmBuddy',
            tags: ['LMS'],
            form: (
                <>
                    <Forms.Text
                        key="gtmBuddyApiUrl"
                        id="gtmBuddyApiUrl"
                        label={st('GtmBuddy/Fields/ApiUrl/Label')}
                        help={st('GtmBuddy/Fields/ApiUrl/Help')}
                        placeholder={st('GtmBuddy/Fields/ApiUrl/Placeholder')}
                        onChange={setGtmBuddyApiUrl}
                        value={gtmBuddyApiUrl}
                    />
                    <Forms.Text
                        key="gtmBuddyApiKey"
                        id="gtmBuddyApiKey"
                        label={st('GtmBuddy/Fields/ApiKey/Label')}
                        help={st('GtmBuddy/Fields/ApiKey/Help')}
                        type="password"
                        onChange={setGtmBuddyApiKey}
                        value={gtmBuddyApiKey}
                    />
                </>
            ),
        },
        {
            key: 'Highspot',
            tags: ['LMS'],
            form: (
                <>
                    <Forms.Text
                        key="highSpotDatalakeHostname"
                        id="highSpotDatalakeHostname"
                        label={st('Highspot/Fields/Hostname/Label')}
                        help={st('Highspot/Fields/Hostname/Help')}
                        placeholder={st('Highspot/Fields/Hostname/Placeholder')}
                        onChange={setHighSpotDatalakeHostname}
                        value={highSpotDatalakeHostname}
                    />
                    <Forms.Text
                        key="highSpotDatalakeVersion"
                        id="highSpotDatalakeVersion"
                        label={st('Highspot/Fields/Version/Label')}
                        help={st('Highspot/Fields/Version/Help')}
                        placeholder={st('Highspot/Fields/Version/Placeholder')}
                        onChange={setHighSpotDatalakeVersion}
                        value={highSpotDatalakeVersion}
                    />
                    <Forms.Text
                        key="highSpotDatalakeUsername"
                        id="highSpotDatalakeUsername"
                        label={st('Highspot/Fields/Username/Label')}
                        help={st('Highspot/Fields/Username/Help')}
                        onChange={setHighSpotDatalakeUsername}
                        value={highSpotDatalakeUsername}
                    />
                    <Forms.Textarea
                        key="highSpotDatalakePrivateKey"
                        id="highSpotDatalakePrivateKey"
                        label={st('Highspot/Fields/PrivateKey/Label')}
                        help={st('Highspot/Fields/PrivateKey/Help')}
                        onChange={setHighSpotDatalakePrivateKey}
                        value={highSpotDatalakePrivateKey}
                        rows="5"
                        type="password"
                        infoHelp={<HighspotHelp />}
                    />
                </>
            ),
        },
        {
            key: 'Hubspot',
            tags: ['CRM'],
            form: (
                <>
                    {hubspotApiKey && !hubspotRefreshToken && (
                        <div>
                            <Forms.Text
                                key="hubspotApiKey"
                                id="hubspotApiKey"
                                label={st('Hubspot/Fields/Key/Label')}
                                help={st('Hubspot/Fields/Key/Help')}
                                onChange={setHubspotApiKey}
                                value={hubspotApiKey}
                            />
                            <div className="mb10">
                                <label className="label label-danger">{st('Hubspot/Fields/Key/Extra')}</label>
                            </div>
                        </div>
                    )}
                    <Forms.Text
                        key="hubspotRefreshToken"
                        id="hubspotRefreshToken"
                        label={st('Hubspot/Fields/Token/Label')}
                        help={st('Hubspot/Fields/Token/Help')}
                        disabled
                        type="password"
                        value={hubspotRefreshToken}
                    />
                    <a href={config.hubspot.auth}>
                        <button className="btn btn-primary">{st('Hubspot/Fields/Token/Authorise')}</button>
                    </a>
                </>
            ),
        },
        {
            key: 'Lessonly',
            tags: ['LMS'],
            form: (
                <>
                    <Forms.Text
                        key="lessonlySubDomain"
                        id="lessonlySubDomain"
                        label={st('Lessonly/Fields/Domain/Label')}
                        help={st('Lessonly/Fields/Domain/Help')}
                        onChange={setLessonlySubDomain}
                        value={lessonlySubDomain}
                    />
                    <Forms.Text
                        key="lessonlyAPIKey"
                        id="lessonlyAPIKey"
                        label={st('Lessonly/Fields/Key/Label')}
                        help={st('Lessonly/Fields/Key/Help')}
                        onChange={setLessonlyAPIKey}
                        value={lessonlyAPIKey}
                        type="password"
                    />
                    <Forms.Label
                        key="lessonlyWebhookEndPoint"
                        id="lessonlyWebhookEndPoint"
                        label={st('Lessonly/Fields/Url/Label')}
                        help={st('Lessonly/Fields/Url/Help')}
                        value={`${config.apiGateway.URL}lessonly/${user.companySettings.guid}?code=${config.apiGateway.LESSONLY}`}
                    />
                </>
            ),
        },
        {
            key: 'LinkedIn',
            tags: ['sales'],
            form: (
                <>
                    <Forms.Toggle
                        key="useLinkedIn"
                        id="useLinkedIn"
                        label={st('LinkedIn/Fields/Use/Label')}
                        onChange={setUseLinkedIn}
                        value={useLinkedIn}
                    />
                    {useLinkedIn && (
                        <div>
                            <Forms.Select
                                key="linkedInAlert"
                                id="linkedInAlert"
                                allowMultiple
                                data={adminUsers}
                                label={st('LinkedIn/Fields/Alert/Label')}
                                help={st('LinkedIn/Fields/Alert/Help')}
                                onChange={setLinkedInAlert}
                                value={linkedInAlert}
                            />
                            <Forms.Label
                                key="linkeInFiles"
                                id="linkeInFiles"
                                label={st('LinkedIn/Fields/Manage/Label')}
                                help=""
                                onClick={() => setShowLinkedIn(true)}
                                value={st('LinkedIn/Fields/Manage/Help')}
                            />
                            <button onClick={() => setShowLinkedIn(true)} className="btn btn-primary">
                                {st('LinkedIn/Buttons/Manage')}
                            </button>
                        </div>
                    )}
                </>
            ),
        },
        {
            key: 'Odbc',
            form: (
                <>
                    <Forms.Text
                        key="odbcName"
                        id="odbcName"
                        label={st('Odbc/Fields/Name/Label')}
                        help={st('Odbc/Fields/Name/Help')}
                        placeholder={st('Odbc/Fields/Name/Placeholder')}
                        onChange={setOdbcName}
                        value={odbcName}
                    />
                    <Forms.Select
                        key="odbcSource"
                        id="odbcSource"
                        label={st('Odbc/Fields/Source/Label')}
                        help={st('Odbc/Fields/Source/Help')}
                        mandatory
                        data={[
                            { id: 'MS-SQL', name: 'MS SQL Server' },
                            { id: 'Postgres', name: 'Postgres DB' },
                        ]}
                        onChange={setOdbcSource}
                        value={odbcSource}
                    />
                    <Forms.Text
                        key="odbcConnection"
                        id="odbcConnection"
                        label={st('Odbc/Fields/Connection/Label')}
                        help={st('Odbc/Fields/Connection/Help')}
                        placeholder={st('Odbc/Fields/Connection/Placeholder')}
                        onChange={setOdbcConnection}
                        value={odbcConnection}
                    />
                    <Forms.Text
                        key="odbcView"
                        id="odbcView"
                        label={st('Odbc/Fields/View/Label')}
                        help={st('Odbc/Fields/View/Help')}
                        placeholder={st('Odbc/Fields/View/Placeholder')}
                        onChange={setOdbcView}
                        value={odbcView}
                    />
                    <div>
                        <div>
                            <button
                                disabled={!(odbcConnection && odbcView)}
                                className="btn btn-primary"
                                onClick={() =>
                                    testConnection(
                                        'odbc',
                                        `?connection=${odbcConnection}&view=${odbcView}&source=${odbcSource}`,
                                        setOdbcTestResult
                                    )
                                }
                            >
                                {st('Odbc/Test')}
                            </button>
                            {odbcTestResult && (
                                <i
                                    title={odbcTestResult}
                                    className={`ml5 fa text-lg ${
                                        odbcTestResult === 'OK' ? 'fa-check-circle text-green' : 'fa-times-circle text-red'
                                    }`}
                                />
                            )}
                        </div>
                    </div>
                </>
            ),
        },
        {
            key: 'Outreach',
            tags: ['sales'],
            form: (
                <>
                    <Forms.Text
                        key="outreachRefreshToken"
                        id="outreachRefreshToken"
                        label={st('Outreach/Fields/Token/Label')}
                        help={st('Outreach/Fields/Token/Help')}
                        disabled
                        type="password"
                        value={outreachRefreshToken}
                    />
                    <a
                        href={config.outreach.auth
                            .replace('<Application_Identifier>', config.outreach.applicationId)
                            .replace('<Redirect_Uri>', encodeURI(config.url) + 'oauth/outreach/')
                            .replace('<Scopes>', encodeURI(config.outreach.scopes))}
                    >
                        <button className="btn btn-primary">{st('Outreach/Authorise')}</button>
                    </a>
                </>
            ),
        },
        {
            key: 'PeopleHR',
            tags: ['users'],
            form: scimUse ? (
                <div>{SystemText('Admin/Integrations/PeopleHR/SCIM')}</div>
            ) : (
                <>
                    <Forms.Toggle
                        key={peopleHRUse}
                        id="peopleHRUse"
                        label={st('PeopleHR/Fields/Use/Label')}
                        help={st('PeopleHR/Fields/Use/Help')}
                        value={peopleHRUse}
                        onChange={setPeopleHRUse}
                    />
                    {peopleHRUse && (
                        <>
                            <Forms.Text
                                key="peopleHRAPIKey"
                                id="peopleHRAPIKey"
                                label={st('PeopleHR/Fields/Key/Label')}
                                help={st('PeopleHR/Fields/Key/Help')}
                                onChange={setPeopleHRAPIKey}
                                value={peopleHRAPIKey}
                            />
                            <Forms.Text
                                key="peopleHRQuery"
                                id="peopleHRQuery"
                                label={st('PeopleHR/Fields/Query/Label')}
                                help={st('PeopleHR/Fields/Query/Help')}
                                onChange={setPeopleHRQuery}
                                value={peopleHRQuery}
                            />
                        </>
                    )}
                </>
            ),
        },
        {
            key: 'Pipedrive',
            tags: ['CRM'],
            form: (
                <Forms.Text
                    key="pipedriveApiKey"
                    id="pipedriveApiKey"
                    label={st('Pipedrive/Fields/Key/Label')}
                    help={st('Pipedrive/Fields/Key/Help')}
                    onChange={setPipedriveApiKey}
                    value={pipedriveApiKey}
                />
            ),
        },
        {
            key: 'Pulse',
            tags: ['LMS'],
            form: (
                <>
                    <Forms.Text
                        key="pulseHost"
                        id="pulseHost"
                        label={st('Pulse/Fields/Host/Label')}
                        placeholder={st('Pulse/Fields/Host/Placeholder')}
                        help={st('Pulse/Fields/Host/Help')}
                        onChange={setPulseHost}
                        value={pulseHost}
                        error={errors.pulseHost}
                    />
                    <Forms.Text
                        key="pulseUsername"
                        id="pulseUsername"
                        label={st('Pulse/Fields/Username/Label')}
                        placeholder={st('Pulse/Fields/Username/Placeholder')}
                        help={st('Pulse/Fields/Username/Help')}
                        onChange={setPulseUsername}
                        value={pulseUsername}
                        error={errors.pulseUsername}
                    />
                    <Forms.Text
                        key="pulsePassword"
                        id="pulsePassword"
                        label={st('Pulse/Fields/Password/Label')}
                        help={st('Pulse/Fields/Password/Help')}
                        onChange={setPulsePassword}
                        value={pulsePassword}
                        type="password"
                        error={errors.pulsePassword}
                    />
                </>
            ),
        },
        salesforce,
        {
            key: 'Salesloft',
            tags: ['sales'],
            form: (
                <Forms.Text
                    key="salesloftApiKey"
                    id="salesloftApiKey"
                    label={st('Salesloft/Fields/Key/Label')}
                    help={st('Salesloft/Fields/Key/Help')}
                    onChange={setSalesloftApiKey}
                    value={salesloftApiKey}
                    type="password"
                />
            ),
        },
        {
            key: 'Sap',
            tags: ['crm'],
            form: (
                <>
                    <Forms.Text
                        key="sapSubDomain"
                        id="sapSubDomain"
                        label={st('SAP/Fields/SubDomain/Label')}
                        help={st('SAP/Fields/SubDomain/Help')}
                        onChange={setSapSubDomain}
                        value={sapSubDomain}
                    />
                    <Forms.Text
                        key="sapUsername"
                        id="sapUsername"
                        label={st('SAP/Fields/Username/Label')}
                        help={st('SAP/Fields/Username/Help')}
                        onChange={setSapUsername}
                        value={sapUsername}
                    />
                    <Forms.Text
                        key="sapPassword"
                        id="sapPassword"
                        label={st('SAP/Fields/Password/Label')}
                        help={st('SAP/Fields/Password/Help')}
                        onChange={setSapPassword}
                        value={sapPassword}
                        type="password"
                    />
                </>
            ),
        },
        {
            key: 'SFTP',
            tags: ['general'],
            form: (
                <SFTP
                    host={sftpHost}
                    setHost={setSftpHost}
                    port={sftpPort}
                    setPort={setSftpPort}
                    username={sftpUsername}
                    setUsername={setSftpUsername}
                    password={sftpPassword}
                    setPassword={setSftpPassword}
                    files={sftpFiles}
                    setFiles={setSftpFiles}
                    errors={errors.sftpLocation}
                />
            ),
        },
        {
            key: 'Showpad',
            tags: ['lms'],
            form: (
                <>
                    <Forms.Label
                        key="showpadRedirectUrl"
                        label="Redirect URL"
                        help="When setting up the OAUTH client in Showpad, you will need to add this value for the Redirect URL"
                        value={config.url + 'oauth/showpad/'}
                    />
                    <Forms.Text
                        key="showpadSubdomain"
                        id="showpadSubdomain"
                        label={st('Showpad/Fields/Subdomain/Label')}
                        help={st('Showpad/Fields/Subdomain/Help')}
                        onChange={setShowpadSubdomain}
                        value={showpadSubdomain}
                    />
                    <Forms.Text
                        key="showpadClientId"
                        id="showpadClientId"
                        label={st('Showpad/Fields/ClientId/Label')}
                        help={st('Showpad/Fields/Clientid/Help')}
                        onChange={setShowpadClientId}
                        value={showpadClientId}
                    />
                    <Forms.Text
                        key="showpadSecret"
                        id="showpadSecret"
                        label={st('Showpad/Fields/Secret/Label')}
                        help={st('Showpad/Fields/Secret/Help')}
                        onChange={setShowpadSecret}
                        value={showpadSecret}
                        type="Password"
                    />
                    <a
                        disabled={!showpadSubdomain || !showpadClientId || !showpadSecret}
                        href={config.showpad.auth
                            .replace('<Subdomain>', showpadSubdomain)
                            .replace('<Client_Id>', fixedEncodeURIComponent(showpadClientId))
                            .replace('<Redirect_Uri>', fixedEncodeURIComponent(config.url + 'oauth/showpad/'))}
                    >
                        <button
                            disabled={!showpadSubdomain || !showpadClientId || !showpadSecret}
                            onClick={save}
                            className="btn btn-primary"
                        >
                            {st('Showpad/Authorise')}
                        </button>
                    </a>
                </>
            ),
        },
        {
            key: 'SAML',
            tags: ['SSO'],
            form: (
                <>
                    <Forms.Label
                        key="samlURL"
                        id="samlURL"
                        label={st('SAML/Fields/Url/Label')}
                        help={st('SAML/Fields/Url/Help')}
                        value={`${config.apiGateway.URL}login/saml/${user.company_Id}?code=${config.apiGateway.CODE}`}
                    />
                    <Forms.Text
                        key="samlEntityId"
                        id="samlEntityId"
                        label={st('SAML/Fields/EntityId/Label')}
                        help={st('SAML/Fields/EntityId/Help')}
                        onChange={setSamlEntityId}
                        value={samlEntityId}
                    />
                    <Forms.Text
                        key="samlLoginUrl"
                        id="samlLoginUrl"
                        label={st('SAML/Fields/LoginUrl/Label')}
                        help={st('SAML/Fields/LoginUrl/Help')}
                        onChange={setSamlLoginUrl}
                        value={samlLoginUrl}
                    />
                    <Forms.Textarea
                        key="samlCertificate"
                        rows="4"
                        id="samlCertificate"
                        label={st('SAML/Fields/Certificate/Label')}
                        help={st('SAML/Fields/Certificate/Help')}
                        onChange={setSamlCertificate}
                        value={samlCertificate}
                    />
                    <Forms.Toggle
                        label={st('SAML/Fields/Only/Label')}
                        help={st('SAML/Fields/Only/Help')}
                        onChange={setSamlOnly}
                        value={samlOnly}
                    />
                </>
            ),
        },
        {
            key: 'SCIM',
            tags: ['users'],
            form: peopleHRUse ? (
                <div>{SystemText('Admin/Integrations/SCIM/PeopleHR')}</div>
            ) : (
                <>
                    <Forms.Toggle
                        key={scimUse}
                        id="scimUse"
                        label={st('SCIM/Fields/Use/Label')}
                        help={st('SCIM/Fields/Use/Help')}
                        value={scimUse}
                        onChange={setScimUse}
                    />
                    {scimUse && (
                        <>
                            <Forms.Label
                                key="scimURL"
                                id="scimURL"
                                label={st('SCIM/Fields/Url/Label')}
                                help={st('SCIM/Fields/Url/Help')}
                                value={`${config.apiGateway.JOB_URL}scim/v2`}
                            />
                            <Forms.Label
                                key={scimToken}
                                id="scimToken"
                                label={st('SCIM/Fields/Token/Label')}
                                help={st('SCIM/Fields/Token/Help')}
                                value={scimToken}
                            />
                            <SaveButton
                                saving={savingSCIM}
                                setSaving={setSavingSCIM}
                                onClick={() => setShowRegenerateWarning(true)}
                                className="btn btn-info mb10"
                            >
                                {st('SCIM/Fields/Token/Regenerate')}
                            </SaveButton>
                            <div>
                                <label>{st('SCIM/Fields/Sync/Label')}</label>
                                {showFormHelp && <span className="form-control-help">{st('SCIM/Fields/Sync/Help')}</span>}
                                <div className="">
                                    {[
                                        'Email',
                                        'Firstname',
                                        'Lastname',
                                        'Manager',
                                        'Department',
                                        'Location',
                                        'BusinessUnit',
                                        'Roles',
                                        'Start',
                                        'Job',
                                        'Licence',
                                    ]
                                        .map(f => ({ id: f, name: st(`SCIM/Fields/${f}`) }))
                                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                                        .map(f => {
                                            const disabled = mandatoryScim.some(x => x === f.id);
                                            return (
                                                <div
                                                    key={f.id}
                                                    className="pointer flex flex-center pb5"
                                                    onClick={
                                                        disabled
                                                            ? null
                                                            : () => {
                                                                  let temp = [...scimSync];
                                                                  if (temp.some(x => x === f.id)) {
                                                                      temp = temp.filter(x => x !== f.id);
                                                                  } else {
                                                                      temp = temp.concat([f.id]);
                                                                  }

                                                                  setScimSync(temp);
                                                              }
                                                    }
                                                >
                                                    <i
                                                        style={{
                                                            width: '15px',
                                                            opacity: disabled ? '0.5' : '1',
                                                        }}
                                                        className={` fa mr5 ${
                                                            scimSync.some(x => x === f.id)
                                                                ? 'fa-check-square text-success'
                                                                : 'fa-square text-disabled'
                                                        }`}
                                                    />
                                                    <span>{f.name}</span>
                                                    <Help id={`SCIM-Help-${f.id}`}>{st(`SCIM/Fields/${f.id}/Help`)}</Help>
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>
                        </>
                    )}
                </>
            ),
        },
        {
            key: 'Snowflake',
            tags: ['general'],
            form: <Snowflake details={snowflakeDetails} setDetails={setSnowflakeDetails} errors={errors.snowflakeDetails} />,
        },
    ]
        .map(i => ({ ...i, title: st(`${i.key}/Title`) }))
        .sort((a, b) => (a.title > b.title ? 1 : -1));

    const footer = (
        <div>
            {showSave && (
                <SaveButton saving={saving} setSaving={setSaving} className="btn btn-success" onClick={() => save()}>
                    {st('Buttons/Save')}
                </SaveButton>
            )}
            <button
                className="btn"
                onClick={() => {
                    setShowForm('');
                    revertForm();
                }}
            >
                {st('Buttons/Cancel')}
            </button>
        </div>
    );

    const filterFields = () => (
        <div className="row">
            <div className="col-md-12">
                <Forms.Text
                    id="filter-box"
                    data-testid="text-filter-field"
                    label={SystemText('Admin/General/Search/Label')}
                    onChange={setSearch}
                    placeholder={SystemText('Admin/General/Search/Placeholder')}
                    value={search}
                    icon="fa-search"
                />
            </div>
        </div>
    );

    return (
        <div>
            <Scroll.Element name="top-of-page" />
            <PageHeader title={st('Title')} adminMenu />
            <section className="content mtm10">
                <SortFilter filterFields={filterFields} filterBoxClassName="filter-raw" />
                {!settings ? (
                    <Loading />
                ) : (
                    <div className="row">
                        {integrations
                            .filter(
                                i =>
                                    `${i.title} ${(i.tags || []).join(' ')}`.toLowerCase().indexOf(search.toLowerCase()) >= 0
                            )
                            .map(i => {
                                return (
                                    <div
                                        className="col-md-3 col-sm-6 text-center mb20"
                                        key={i.key}
                                        onClick={() => setShowForm(i.key)}
                                    >
                                        <div className="flex flex-column integration-badge">
                                            <img
                                                alt=""
                                                loading="lazy"
                                                src={`/dist/img/integrations/${i.key.toLowerCase()}.png`}
                                                style={{ width: '100%' }}
                                            />
                                            <div className="mt10">{i.title}</div>
                                        </div>
                                    </div>
                                );
                            })}
                        <Modal
                            show={showForm}
                            close={() => setShowForm('')}
                            title={st(`${showForm}/Title`)}
                            footer={footer}
                            toggleFormHelp={() => dispatch(toggleFormHelp())}
                        >
                            {integrations.map(i => {
                                return (
                                    <div style={{ display: showForm === i.key ? '' : 'none' }} key={`form-${i.key}`}>
                                        {i.form}
                                    </div>
                                );
                            })}
                        </Modal>
                    </div>
                )}
            </section>
            <LinkedIn show={showLinkedIn} close={() => setShowLinkedIn(false)} />
            <DeleteWarning
                message={st('SCIM/Fields/Token/Warning')}
                show={showRegenerateWarning}
                close={confirm => regenerateSCIM(confirm)}
            />
        </div>
    );
};

export default AdminIntegrations;
